module.exports = __webpack_public_path__ + "static/img/team-1.66f62826.jpg";